// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__8sQHd","list":"PatternAutocomplete_list__2WgGH"};